(() => {
  // 防止同一个页面重复绑定点击事件。
  if (window.__customBuyNowInitialized) return;
  window.__customBuyNowInitialized = true;

  // 优先使用主题现有的商品表单错误区域显示错误。
  const showError = (form, message) => {
    const productForm = form.closest('product-form');
    const errorWrapper = productForm?.querySelector(
      '.product-form__error-message-wrapper'
    );
    const errorMessage = productForm?.querySelector(
      '.product-form__error-message'
    );

    if (errorWrapper && errorMessage) {
      errorMessage.textContent = message;
      errorWrapper.hidden = false;
    } else {
      console.error(message);
    }
  };

  // 新请求开始前隐藏上一次的错误提示。
  const hideError = (form) => {
    const errorWrapper = form
      .closest('product-form')
      ?.querySelector('.product-form__error-message-wrapper');

    if (errorWrapper) {
      errorWrapper.hidden = true;
    }
  };

  // 控制按钮的加载动画与禁用状态，防止重复点击。
  const setLoading = (button, loading) => {
    button.dataset.buyNowLoading = loading ? 'true' : 'false';
    button.classList.toggle('is-loading', loading);
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
    button.disabled = loading;
  };

  // 让 Jetzt kaufen 与原加入购物车按钮保持相同的可售状态。
  const syncAvailability = (button) => {
    const form = button.closest('form');
    const addButton = form?.querySelector('[name="add"]');

    // 正在跳转时保持禁用，不能被规格切换逻辑重新启用。
    if (
      !addButton ||
      button.dataset.buyNowLoading === 'true'
    ) {
      return;
    }

    button.disabled = addButton.disabled;
  };

  // 监听原加入购物车按钮的 disabled 变化，同步缺货状态。
  const initializeButton = (button) => {
    if (
      button.dataset.buyNowAvailabilityBound === 'true'
    ) {
      return;
    }

    const form = button.closest('form');
    const addButton = form?.querySelector('[name="add"]');

    if (!addButton) return;

    button.dataset.buyNowAvailabilityBound = 'true';

    syncAvailability(button);

    new MutationObserver(() => {
      syncAvailability(button);
    }).observe(addButton, {
      attributes: true,
      attributeFilter: ['disabled']
    });
  };

  // 初始化页面上的立即购买按钮。
  const initializeButtons = (root = document) => {
    root
      .querySelectorAll('[data-buy-now-button]')
      .forEach(initializeButton);
  };

  // 初次打开商品页时初始化。
  initializeButtons();

  // Shopify 主题编辑器重新加载 Section 后重新初始化。
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeButtons(event.target);
    }
  );

  // 从结账页后退时，浏览器可能恢复跳转前的禁用状态。
  // 使用 pageshow 统一清除 loading，并重新同步库存状态。
  window.addEventListener('pageshow', () => {
    document
      .querySelectorAll('[data-buy-now-button]')
      .forEach((button) => {
        setLoading(button, false);
        syncAvailability(button);
      });
  });

  // 使用事件委托，兼容 Shopify Section 动态重新加载。
  document.addEventListener('click', async (event) => {
    const button = event.target.closest(
      '[data-buy-now-button]'
    );

    if (!button || button.disabled) return;

    const form = button.closest('form');
    const addButton = form?.querySelector('[name="add"]');

    if (!form) return;

    // 从 Liquid 写入的 data 属性读取结账基础路径和提示文案。
    const cartPermalinkBase =
      button.dataset.cartPermalinkBase;

    const soldOutMessage =
      button.dataset.soldOutMessage ||
      'Ausverkauft';

    const missingVariantMessage =
      button.dataset.missingVariantMessage ||
      'Bitte wählen Sie eine Produktvariante aus.';

    const addErrorMessage =
      button.dataset.addErrorMessage ||
      'Das Produkt konnte nicht zum Warenkorb hinzugefügt werden.';

    // 防止规格状态切换过程中提交缺货商品。
    if (addButton?.disabled) {
      showError(form, soldOutMessage);
      return;
    }

    hideError(form);
    setLoading(button, true);

    try {
      const formData = new FormData(form);

      const variantId = String(
        formData.get('id') || ''
      ).trim();

      const quantity = Number.parseInt(
        String(formData.get('quantity') || '1'),
        10
      );

      // Variant ID 必须是有效的数字 ID。
      if (!/^\d+$/.test(variantId)) {
        throw new Error(missingVariantMessage);
      }

      // 数量必须是不小于 1 的整数。
      if (
        !Number.isInteger(quantity) ||
        quantity < 1 ||
        !cartPermalinkBase
      ) {
        throw new Error(addErrorMessage);
      }

      const currentProductCheckoutUrl =
        `${cartPermalinkBase}` +
        `${encodeURIComponent(variantId)}:` +
        `${quantity}`;

      window.location.assign(
        currentProductCheckoutUrl
      );
    } catch (error) {
      // 失败时恢复按钮，并允许用户修改规格后重试。
      showError(
        form,
        error instanceof Error
          ? error.message
          : addErrorMessage
      );

      setLoading(button, false);
      syncAvailability(button);
    }
  });
})();